import React from "react";
import Skeleton from 'react-loading-skeleton';

export default function MyPetListRowSkeleton() {
    return (
        <div className="flex flex-row items-center gap-3">
            {/* Avatar Skeleton */}
            <div className="py-3 shrink-0">
                <Skeleton width={48} height={48} borderRadius={4} className="sm:!w-14 sm:!h-14" />
            </div>
            
            {/* Content Skeleton with divider */}
            <div className="flex-1 min-w-0 self-stretch flex flex-row items-center border-b border-gray-100 dark:border-white/5 py-3">
                <div className="flex-1 min-w-0 flex flex-col justify-center gap-2">
                    <Skeleton width="40%" height={16} />
                    <Skeleton width="30%" height={12} />
                </div>
                
                {/* Arrow Skeleton */}
                <Skeleton width={16} height={16} />
            </div>
        </div>
    );
}
